import type { ProjectSettingsType } from './types';

const legalOperatorName: string = import.meta.env.LEGAL_OPERATOR_NAME ?? '';
const legalContactEmail: string = import.meta.env.LEGAL_CONTACT_EMAIL ?? '';
const legalIsTestData: boolean = import.meta.env.LEGAL_TEST_DATA === 'true';

const ProjectSettings: ProjectSettingsType = {
  project: {
    name: 'Family Space',
  },

  loading: {
    screenDelay: false,
  },

  auth: {
    landingUrl: import.meta.env.LANDING_URL,
    serviceUrl: import.meta.env.AUTH_BASE_URL,
  },

  account: {
    url: import.meta.env.FAMILY_ACCOUNT_URL,
  },

  chat: {
    serviceUrl: import.meta.env.CHAT_BASE_URL,
    messages: {
      cache: {
        maxChats: 10,
      },
      pageSize: 50,
    },
  },

  user: {
    typing: {
      debounce: 1.5 * 1000,
      resetTimeout: 3 * 1000,
    },
  },

  pwa: {
    enabled: import.meta.env.PWA_ENABLED,
    installBannerDelay: 1.5 * 1000,
  },

  pushNotifications: {
    enabled: import.meta.env.PUSH_NOTIFICATIONS_ENABLED,
  },

  cookie: {
    installBannerDelay: 1.5 * 1000,
  },

  legal: {
    contactEmail: legalContactEmail,
    isProductionReady: Boolean(legalOperatorName && legalContactEmail) && !legalIsTestData,
    isTestData: legalIsTestData,
    operatorName: legalOperatorName,
  },

  shared: {
    resizablePabel: {
      width: {
        default: 350,
        min: 300,
        max: 600,
      },
    },
  },
};

export { ProjectSettings };
